var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M200 400C89.543 400 0 310.457 0 200S89.543 0 200 0s200 89.543 200 200-89.543 200-200 200zm67.882-131.118c5.091-5.09 5.091-11.88 0-16.97L216.971 201l50.911-50.912c5.091-5.09 5.091-11.88 0-16.97-5.09-5.091-11.88-5.091-16.97 0L200 184.029l-50.912-50.911c-5.09-5.091-11.88-5.091-16.97 0-5.091 5.09-5.091 11.88 0 16.97L183.029 201l-50.911 50.912c-5.091 5.09-5.091 11.88 0 16.97 5.09 5.091 11.88 5.091 16.97 0L200 217.971l50.912 50.911c5.09 5.091 11.88 5.091 16.97 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.fc06cd7087d85a12336518a6234f45d5.svg";
export { ForwardRef as ReactComponent };